// O STATUS NA FOLHA que o bate-carteira mostra para cada contrato (#347).
//
// Antes disto, o bate-carteira classificava em tres lugares — a API
// (`bate-carteira-regras.ts`) e uma copia em cada tela — e a copia das telas
// mandava para "Conciliado" tudo que nao reconhecia. A Alvo Card viu 136 linhas
// "Conciliado" para 69 contratos, com `falha`, `parcial` e `suspensa_sem_folha`
// entre elas (Morada Nova, 09/2026).
//
// Agora o mapeamento e' um so', aqui, e o `switch` e' exaustivo: um resultado
// novo em `RESULTADO_DESCONTO` nao compila ate' alguem decidir o que ele e'.
//
// So' `aplicada` e' conciliado. `parcial` descontou menos que o instruido;
// `suspensa` nao descontou porque nao havia de onde (sem folha no mes, ou o teto
// do orgao cortou); `nao_descontada` e' a folha que podia e nao descontou, ou o
// servidor desligado. `recebida` e' o estado antes do retorno: para quem confere
// a carteira, ainda nao ha resposta.
export function statusNaFolha(resultado) {
    if (resultado == null)
        return "aguardando_retorno";
    switch (resultado) {
        case "aplicada":
            return "aplicada";
        case "parcial":
            return "parcial";
        case "falha":
        case "interrompida_desligamento":
            return "nao_descontada";
        case "suspensa_sem_folha":
        case "suspensa_por_teto":
            return "suspensa";
        case "recebida":
            return "aguardando_retorno";
        default: {
            const nunca = resultado;
            throw new Error(`resultado de desconto sem status na folha: ${String(nunca)}`);
        }
    }
}
/** A folha descontou o instruido inteiro — o unico status que concilia. */
export function conciliadoNaFolha(status) {
    return status === "aplicada";
}
export const ROTULO_STATUS_NA_FOLHA = {
    aplicada: "Descontado",
    parcial: "Descontado em parte",
    nao_descontada: "Não descontado",
    suspensa: "Suspenso",
    aguardando_retorno: "Aguardando retorno",
};
/** O que exige acao primeiro (cliente 12/08/2026, item 3): o que nao descontou,
 *  depois o parcial, o suspenso, o que ainda espera, e por fim o conciliado. */
export const PESO_STATUS_NA_FOLHA = {
    nao_descontada: 0,
    parcial: 1,
    suspensa: 2,
    aguardando_retorno: 3,
    aplicada: 4,
};
//# sourceMappingURL=status-na-folha.js.map